module.exports = __webpack_public_path__ + "img/startup-light.db61ca38.png";